

export const techdata = [
    {
        title: 'Launch vehicle',
        description: " A launch vehicle or carrier rocket is a rocket-propelled vehicle used to carry a payload from Earth's surface to space usually to Earth orbit or beyond. Our WEB-X carrier rocket is the most powerful in operation. Standing 150 metres tall, it's quite an awe-inspiring sight on the launch pad!",
        imgLarge: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-launch-vehicle-portrait_tpvbpo.jpg',
        imgTablet: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-launch-vehicle-landscape_f6gu3v.jpg',
        alt: 'Launch vehicle',
    },
    {
        title: 'Spaceport',
        description: " A spaceport or cosmodrome is a site for launching (or receiving) spacecraft, by analogy to the seaport for ships or airport for aircraft. Based in the famous Cape Canaveral, our spaceport is ideally situated to take advantage of the Earth’s rotation for launch.",
        imgLarge: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-spaceport-portrait_sw8dmi.jpg',
        imgTablet: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-spaceport-landscape_uelxdd.jpg',
        alt: 'Spaceport',
    },
    {
        title: 'Space capsule',
        description: "A space capsule is an often-crewed spacecraft that uses a blunt-body reentry capsule to reenter the Earth's atmosphere without wings. Our capsule is where you'll spend your time during the flight. It includes a space gym, cinema, and plenty of other activities to keep you entertained.",
        imgLarge: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-space-capsule-portrait_ldeym3.jpg',
        imgTablet: 'https://res.cloudinary.com/soyousay/image/upload/v1657446707/space_tours/Technology/image-space-capsule-landscape_fg7nu8.jpg',
        alt: 'Space capsule',
    },
]